import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AlertMessageModule} from "../../lib/alert-message/alert-message.module";
import {EmailEditModalComponent} from "./email-edit-modal.component";
import {FormsModule} from "@angular/forms";
import {EmailRegexValidatorModule} from "../../lib/email-regex-validator/email-regex-validator.module";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {TooltipModule} from "ngx-bootstrap/tooltip";
import {TooltipEllipsifyModule} from "../../directives/tooltip-ellipsify/tooltip-ellipsify.module";
import {ProfileService} from "../../services/profile/profile.service";
import { ButtonModule } from '@xref/xref-lib';

@NgModule({
  declarations: [EmailEditModalComponent],
  imports: [
    CommonModule,
    FormsModule,
    AlertMessageModule,
    EmailRegexValidatorModule,
    NgbModule,
    ButtonModule,
    TooltipModule.forRoot(),
    TooltipEllipsifyModule,
  ],
  exports: [EmailEditModalComponent],
  providers: [ProfileService]
})
export class EmailEditModalModule {
}
